import React from "react";
import { useNavigate } from "react-router-dom";
import dirtbike from "../Images/DirtBike.jpg";
import scuba from "../Images/Scuba.jpg";
import whitewater from "../Images/Whitewater.jpg";

const VisionSection = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full flex flex-col items-center justify-center py-16 md:py-20">
      {/* Carousel */}
      <div className="flex gap-6 md:gap-10 snap-x snap-mandatory overflow-x-auto scroll-smooth px-4 max-w-full md:max-w-6xl">
        
        {/* Card 1 – Image */}
        <div className="min-w-[260px] sm:min-w-[300px] md:min-w-[320px] h-[380px] sm:h-[450px] md:h-[500px] snap-start rounded-2xl md:rounded-3xl overflow-hidden shadow-xl bg-white hover:scale-105 transition-transform duration-500">
          <img src={dirtbike} alt="Dirt Bike" className="w-full h-full object-cover" />
        </div>

        {/* Card 2 – Text */}
        <div className="min-w-[260px] sm:min-w-[300px] md:min-w-[320px] h-[380px] sm:h-[450px] md:h-[500px] snap-start p-6 sm:p-8 bg-[#B3989E]/15 backdrop-blur-xl rounded-2xl md:rounded-3xl shadow-xl flex flex-col justify-center hover:shadow-2xl transition">
          <h3 className="text-2xl sm:text-3xl font-perandory font-semibold text-[#007AA3] mb-2 text-center md:text-left">
            FROM VISION TO VISTA
          </h3>
          <p className="text-gray-700 font-belleza text-justify text-sm sm:text-base leading-relaxed">
            Bringing your travel vision to life starts with understanding YOU — your passions, preferences, and personal rhythm. With that insight, we craft a bespoke journey blueprint, thoughtfully curating destinations and experiences that don’t just meet your expectations, but elevate them.
          </p>
        </div>

        {/* Card 3 – Image */}
        <div className="min-w-[260px] sm:min-w-[300px] md:min-w-[320px] h-[380px] sm:h-[450px] md:h-[500px] snap-start rounded-2xl md:rounded-3xl overflow-hidden shadow-xl bg-white hover:scale-105 transition-transform duration-500">
          <img src={scuba} alt="Scuba" className="w-full h-full object-cover" />
        </div>

        {/* Card 4 – Text */}
        <div className="min-w-[260px] sm:min-w-[300px] md:min-w-[320px] h-[380px] sm:h-[450px] md:h-[500px] snap-start p-6 sm:p-8 bg-[#B3989E]/15 backdrop-blur-xl rounded-2xl md:rounded-3xl shadow-xl flex flex-col justify-center hover:shadow-2xl transition">
          <h3 className="text-2xl sm:text-3xl font-perandory font-semibold text-[#007AA3] mb-2 text-center md:text-left">
            ESCAPE THE CHAOS
          </h3>
          <p className="text-gray-700 font-belleza text-justify text-sm sm:text-base leading-relaxed">
            From the first detail to your journey home, every element is thoughtfully designed and flawlessly managed, freeing you to embrace the experience, forge meaningful connections, and travel with effortless elegance.
          </p>
        </div>

        {/* Card 5 – Image */}
        <div className="min-w-[260px] sm:min-w-[300px] md:min-w-[320px] h-[380px] sm:h-[450px] md:h-[500px] snap-start rounded-2xl md:rounded-3xl overflow-hidden shadow-xl bg-white hover:scale-105 transition-transform duration-500">
          <img src={whitewater} alt="Whitewater" className="w-full h-full object-cover" />
        </div>
      </div>

      {/* CTA Button */}
      <button 
        onClick={()=> navigate("/services")}
        className="mt-8 md:mt-10 font-garet font-semibold text-sm sm:text-[14.5px] border-[#007AA3] border-2 text-[#007AA3] py-2 px-4 sm:py-1 sm:px-3 rounded-sm hover:bg-[#007AA3] hover:text-[#D4AF37] transition"
      >
        TRAVEL SERVICES
      </button>
    </div>
  );
};

export default VisionSection;
